<template>
  <a
    :class="[extraClasses, disabledClasses]"
    class="sf-btn"
    data-walkthrough-id="new-remark-button"
    @click="openModal"
    @mousedown="saveSelection"
    >{{ I18n.t('communication.add_remark') }}</a
  >
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useStore } from 'vuex'

import { isCurrentWorkflowLocked } from '@app/adapters/silverfin'
import { stringToQuote } from '@app/utils/string-helpers'

defineOptions({
  name: 'NewRemarkButton',
})

const props = defineProps({
  ownerType: String,
  ownerId: [String, Number],
  ledgerId: [String, Number],
  ledgerLabel: String,
  extraClasses: String,
  showTags: {
    type: Boolean,
    default: true,
  },
})

const selectedText = ref(null)
const store = useStore()

const disabled = isCurrentWorkflowLocked()

const disabledClasses = disabled ? ['sf-btn-disabled'] : []

const allRemarkTags = computed(
  () => store.state?.remarkTags?.allRemarkTags || {}
)

const remarkContext = computed(() => {
  const newRemarkText = stringToQuote(selectedText.value)

  return {
    ownerType: props.ownerType,
    ownerId: props.ownerId,
    ledgerId: props.ledgerId,
    ledgerLabel: props.ledgerLabel,
    text: newRemarkText,
    allRemarkTags: allRemarkTags.value,
    showTags: props.showTags,
  }
})

const openModal = (payload = {}) => {
  window.modalCitizen.openModal('new-remark', {
    ...remarkContext.value,
    ...payload,
  })
}

const saveSelection = () => {
  selectedText.value = window.getSelection().toString()
}

onMounted(() => {
  window.eventHub.$on('openNewRemarkModal', openModal)
})

onBeforeUnmount(() => {
  window.eventHub.$off('openNewRemarkModal', openModal)
})
</script>
